import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange, handleReadTimeOffsetChange }) => {
  var _a;
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { graphThrottleEnabled, readTimeOffset, timeoutGracePeriodMinutes } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  const internalHandleReadTimeOffsetChange = (e) => {
    const { value } = e.target;
    if (value >= 0) {
      onChange(e);
      handleReadTimeOffsetChange("");
    } else {
      handleReadTimeOffsetChange("Read Time Offset cannot be negative");
    }
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(ThrottlingCheckbox, { id: "graphThrottleEnabled", defaultChecked: graphThrottleEnabled == null ? void 0 : graphThrottleEnabled.value, onChange }), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "readTimeOffset",
      type: "number",
      value: readTimeOffset.value,
      min: "0",
      onChange: internalHandleReadTimeOffsetChange,
      required: true,
      help: "How long to wait for logs to become available in the Microsoft Graph API before attempting to read them.",
      label: "Read Time Offset (minutes)"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "timeoutGracePeriodMinutes",
      type: "number",
      min: "1",
      value: (_a = timeoutGracePeriodMinutes == null ? void 0 : timeoutGracePeriodMinutes.value) != null ? _a : "",
      onChange,
      label: "Timeout Grace Period (minutes)",
      help: "How long repeated Microsoft Graph timeouts must continue before the input is marked as failing."
    }
  ));
};
export default FormAdvancedOptions;
